import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../services/supabase";
import Chapter01 from "./../assets/images/chapter-01.webp";
import Chapter02 from "./../assets/images/chapter-02.webp";
import Chapter03 from "./../assets/images/chapter-03.webp";
import Chapter04 from "./../assets/images/chapter-04.webp";
import Chapter05 from "./../assets/images/chapter-05.webp";
import Chapter06 from "./../assets/images/chapter-06.webp";
import Chapter07 from "./../assets/images/chapter-07.webp";
import IllustrationWebgl from "./../assets/images/illustration-webgl.webp";
import IllustrationMathematics from "./../assets/images/illustration-mathematics.webp";
import Illustration3DSoftware from "./../assets/images/illustration-3d-software.webp";
import IllustrationJavascript from "./../assets/images/illustration-javascript.webp";
import IllustrationComputer from "./../assets/images/illustration-computer.webp";

const images = [
  Chapter01,
  Chapter02,
  Chapter03,
  Chapter04,
  Chapter05,
  Chapter06,
  Chapter07,
  IllustrationWebgl,
  IllustrationMathematics,
  Illustration3DSoftware,
  IllustrationJavascript,
  IllustrationComputer,
];

function Home() {
  const navigate = useNavigate();
  const [parentCategories, setParentCategories] = useState([]);

  useEffect(() => {
    fetchParentCategories();
  }, []);

  const fetchParentCategories = async () => {
    const { data, error } = await supabase
      .from("categories")
      .select("*")
      .eq("parentid", 0);
    if (data) setParentCategories(data);
  };
  const navigateToStudio = (id) => {
    navigate("/studio/" + id);
  };
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
        {parentCategories.map((category, index) => (
          <div
            key={category.id}
            className="bg-gray-900 rounded-lg overflow-hidden text-center text-white p-2.5"
            onClick={() => {
              navigateToStudio(category.id)
            }}
          >
            <img
              className="w-full h-auto rounded-lg hover:cursor-pointer hover:scale-95"
              style={{
                objectFit: "fit",
                aspectRatio: "16 / 9",
                background: "#fff",
                opacity: "0.85",
              }}
              src={
                category.image ||
                (index > images.length - 1 ? images[0] : images[index])
              }
              alt={category.name}
            />
            <div
              className="rounded-lg text-lg text-center font-bold mt-2.5 pt-2 min-h-[40px] hover:cursor-pointer"
              style={{
                background:
                  "radial-gradient(150% 200% at 120% 50%,rgba(255,119,241,.2) 0%,rgba(20,11,41,.2) 100%),#140b29",
              }}
            >
              {category.name}
            </div>
          </div>
        ))}
      </div>
      {/* <ul className="grid grid-cols-3 gap-4 mt-4">
        {parentCategories.map((category) => (
          <li key={category.id}>
            <Link to={`/studio/${category.id}`}>{category.name}</Link>
          </li>
        ))}
      </ul> */}
    </>
  );
}

export default Home;
